import React from "react";
import { LogOut } from "lucide-react";

export default function MobileSidebar({
  showMobileMenu,
  setShowMobileMenu,
  navItems,
  location,
  navigate,
  user,
  displayName,
  handleLogoutClick,
  logo,
}) {
  if (!showMobileMenu) return null;

  return (
    <>
      {/* OVERLAY */}
      <div
        className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
        onClick={() => setShowMobileMenu(false)}
      />

      {/* SIDEBAR */}
      <div
        className="
          fixed top-0 left-0 h-screen
          w-[76%] max-w-[260px]
          bg-white z-50 lg:hidden
          shadow-2xl
          rounded-r-[24px]
          overflow-hidden
          animate-slideIn
          flex flex-col
        "
      >
        {/* HEADER */}
        <div className="relative bg-gradient-to-br from-red-500 via-red-500 to-red-600 px-4 pt-3 pb-3 text-white">

          {/* TOP */}
          <div className="flex items-center justify-between">

            {/* LOGO */}
            <div className="flex items-center gap-2 min-w-0">

              <div className="bg-white/20 p-1.5 rounded-lg backdrop-blur-sm">
                <img
                  src={logo}
                  alt="logo"
                  className="h-5 object-contain brightness-0 invert"
                />
              </div>

              <div className="min-w-0 leading-tight">
                {/* <h2 className="font-semibold text-sm truncate">
                  Medrpha
                </h2> */}

                <p className="text-[9px] text-red-100 truncate">
                  Healthcare Services
                </p>
              </div>
            </div>

            {/* CLOSE BUTTON */}
            <button
              onClick={() => setShowMobileMenu(false)}
              className="
                w-7 h-7 rounded-lg
                bg-white/20
                hover:bg-white/30
                flex items-center justify-center
                text-[13px]
                transition-all duration-200
                flex-shrink-0
              "
            >
              ✕
            </button>
          </div>

          {/* USER */}
          {user && (
            <div className="mt-3 flex items-center gap-2.5">

              {/* AVATAR */}
              <div
                className="
                  w-9 h-9 rounded-full
                  bg-white/20
                  flex items-center justify-center
                  text-xs font-bold uppercase
                  flex-shrink-0
                  border border-white/20
                "
              >
                {displayName?.charAt(0)}
              </div>

              {/* INFO */}
              <div className="min-w-0 flex-1 leading-tight">
                
                <p className="text-[8px] text-red-100">
                  Welcome Back 👋
                </p>

                <h3 className="font-semibold text-xs truncate">
                  {displayName}
                </h3>

                <p className="text-[8px] text-red-100 truncate">
                  {user?.phoneNumber ||
                    user?.email ||
                    ""}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* NAV ITEMS */}
        <div className="flex-1 overflow-y-auto px-3 py-3 flex flex-col gap-2">

          {navItems.map((item, index) => {
            const isActive =
              location.pathname === item.route &&
              (!item.from ||
                location.state?.from === item.from);

            return (
              <button
                key={index}
                onClick={() => {
                  navigate(item.route, {
                    state: {
                      from: item.from,
                      name: item.name,
                    },
                  });

                  setShowMobileMenu(false);
                }}
                className={`
                  group flex items-center gap-2.5
                  px-3 py-2 rounded-xl
                  text-xs font-medium
                  transition-all duration-300

                  ${
                    isActive
                      ? "bg-gradient-to-r from-red-500 to-red-600 text-white shadow-md"
                      : "bg-gray-50 hover:bg-red-50 text-gray-700"
                  }
                `}
              >
                {/* ICON */}
                <div
                  className={`
                    w-8 h-8 rounded-lg
                    flex items-center justify-center
                    transition-all duration-300
                    flex-shrink-0

                    ${
                      isActive
                        ? "bg-white/20"
                        : "bg-white text-red-500 shadow-sm"
                    }
                  `}
                >
                  {item.icon}
                </div>

                {/* LABEL */}
                <div className="flex-1 text-left min-w-0">

                  <p className="truncate text-xs font-semibold">
                    {item.name}
                  </p>

                  <p
                    className={`text-[9px] truncate mt-[1px]
                      ${
                        isActive
                          ? "text-red-100"
                          : "text-gray-400"
                      }
                    `}
                  >
                    Open {item.name}
                  </p>
                </div>

                {/* DOT */}
                <div
                  className={`
                    w-1.5 h-1.5 rounded-full
                    ${
                      isActive
                        ? "bg-white"
                        : "bg-red-300"
                    }
                  `}
                />
              </button>
            );
          })}
        </div>

        {/* LOGOUT */}
        {user && (
          <div className="p-3 border-t bg-white">

            <button
              onClick={handleLogoutClick}
              className="
                w-full flex items-center justify-center gap-2
                px-4 py-2.5 rounded-xl
                bg-gradient-to-r from-red-500 to-red-600
                text-white text-xs font-semibold
                shadow-lg
                hover:scale-[1.01]
                active:scale-[0.98]
                transition-all duration-300
              "
            >
              <LogOut size={15} />

              Logout
            </button>
          </div>
        )}
      </div>
    </>
  );
}